/* Core & libraries */
import React, {useEffect, useState} from "react";

/* Helpers, constants, custom methods, internal libraries */
import { useGenericApiFetch }  from "../endpoints/base";
import {
  POWER_BI_CONFIG_ENDPOINT, POWER_BI_SUMMARY_CONFIG_ENDPOINT,
} from '../endpoints/endpoints';


/* Components */
/* Styles */

export const usePowerBiService = () => {

  const [powerBiConfig, setPowerBiConfig] = useState(null)
  const [summaryPowerBiConfig, setSummaryPowerBiConfig] = useState(null)
  const { genericApiFetch } = useGenericApiFetch();


  const getPowerBiConfig = async (companyEntityId) => {

    const response = await genericApiFetch({
      url: POWER_BI_CONFIG_ENDPOINT.replace("{companyEntityId}", companyEntityId),
      method: "GET",
    });
    if (response.success) {
      setPowerBiConfig(response.data);
      return true;
    }
    return false;
  };

  const getSummaryPowerBiConfig = async (companyEntityId) => {
    const response = await genericApiFetch({
      url: POWER_BI_SUMMARY_CONFIG_ENDPOINT.replace("{companyEntityId}", companyEntityId),
      method: "GET",
    });
    if (response.success) {
      setSummaryPowerBiConfig(response.data);
      return true;
    }
    return false;
  };

  return {
    powerBiConfig,
    getPowerBiConfig,
    summaryPowerBiConfig,
    getSummaryPowerBiConfig
  };
}